import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TenderingService } from 'src/app/services/tendering/tendering.service';
import { Enquiryheader } from 'src/app/model/enquiryheader.model';
import { NgForm, FormsModule } from '@angular/forms';

@Component({
  selector: 'app-techquote',
  templateUrl: './techquote.component.html',
  styleUrls: ['./techquote.component.css']
})
export class TechquoteComponent implements OnInit {

  stepno: string;
  enquiryData : any;
  enquiryHeader : Enquiryheader;

  constructor(private router: Router, private route: ActivatedRoute,
    private tenderingServices: TenderingService) {
    this.stepno = this.route.snapshot.params.enquiryid;
  }

  ngOnInit() {
    this.getEnquiryById();
  }

  getEnquiryById() {
    this.tenderingServices.GetEnquiryById(this.stepno).subscribe(
      data => {
        this.enquiryData = data;
        this.enquiryHeader = this.enquiryData;
        console.log(this.enquiryHeader);
      }
    )
  }

  SubmitTechQuoteForm(form: NgForm) {

    //console.log(form.value);
    form.value.quoteType = "tech";
    this.tenderingServices.InviteTechQuote(form.value).subscribe(
      data => {
        alert("Successfully Submitted");
      }
    );

  }

}
